export default class CloseSuperHeader {
  init() {
    const closeBtn = document.querySelector(".close-icon");
    const superHeader = document.querySelector(".superheader");

    if (superHeader) {
      closeBtn.addEventListener("click", () => {
        superHeader.style.display = "none";
      });
    }
  }
}
